import React, { useState } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

// bootstrap
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";

// routing
import { Link, useLocation } from "react-router-dom";

// component
import OnboardingProgress from "./OnboardingProgress";
import TakeTourModal from "./TakeTourModal";

const shouldRenderCaseReport = (atPatientControlPage, user) => {
    return (
        !atPatientControlPage &&
        (user.userType === "Therapist" || user.userType === "provider")
    );
};

const authenticatedOptions = (atPatientControlPage, user, t, onOpenTour, isFreeTrial) => (
    <>
        {!atPatientControlPage && !isFreeTrial && (
            <Nav.Link eventKey="/home" as={Link} to="/">
                {t("header.navbar.home")}
            </Nav.Link>
        )}
        <Nav.Link eventKey="/media" as={Link} to="/media">
            {t("header.navbar.media")}
        </Nav.Link>
        {!atPatientControlPage && !isFreeTrial && (
            <Nav.Link eventKey="/charts" as={Link} to="/charts">
                {t("header.navbar.report")}
            </Nav.Link>
        )}
        {/*{shouldRenderCaseReport(atPatientControlPage, user) && (
            <Nav.Link eventKey="/caseReport" as={Link} to="/caseReport">
                {t("header.navbar.case_report")}
            </Nav.Link>
        )} */}
        {!atPatientControlPage && !isFreeTrial && (
            <Nav.Link
                href="#"
                role="button"
                className="text-yellow-500 drop-shadow-[0_0_6px_rgba(253,224,71,0.9)] hover:text-yellow-400 transition ease-in-out duration-150 animate-pulse"
                onClick={(e) => {
                    e.preventDefault();
                    onOpenTour && onOpenTour();
                }}
            >
                {t("header.navbar.take_a_tour")}
            </Nav.Link>
        )}
    </>
);
const userDropDownItems = (userType, t, isFreeTrial) => (
    <>
        <NavDropdown.Item as={Link} to="/signOut">
            {t("header.navbar.logout")}
        </NavDropdown.Item>
        {!isFreeTrial && userType != "provider" && (
            <NavDropdown.Item as={Link} to="/accountSetting">
                {t("header.navbar.account_settings")}
            </NavDropdown.Item>
        )}
        {!isFreeTrial && (userType == "provider" || userType == "Therapist") && (
            <NavDropdown.Item as={Link} to="/PaymentPage">
                {t("header.navbar.membership_payment")}
            </NavDropdown.Item>
        )}
    </>
);
const unauthenticatedOptions = (t) => (
    <>
        <Nav.Link eventKey="/register" as={Link} to="/register">
            {t("header.navbar.register")}
        </Nav.Link>
        <Nav.Link eventKey="/signIn" as={Link} to="/signIn">
            {t("header.navbar.signin")}
        </Nav.Link>
    </>
);

const Header = ({ user, routeGroup, onboardingPercent, isFreeTrial }) => {
    const { t, language } = useTranslation();
    const [showTour, setShowTour] = useState(false);

    // used to keep the current link active
    const location = useLocation();

    if (routeGroup === "onboarding" || routeGroup === "laterSymptoms")
        return (
            <>
                <Navbar
                    className="mb-12"
                    id="nav-border"
                    collapseOnSelect
                    expand="md"
                >
                    <Nav style={{ width: "100%" }}>
                        <Nav.Item
                            onboardingPercent={onboardingPercent}
                            as={OnboardingProgress}
                        />
                    </Nav>
                </Navbar>
                <div className="flex justify-end">
                    <Nav.Link
                        style={{ marginTop: "-40px" }}
                        eventKey="/logout"
                        as={Link}
                        to="/signOut"
                    >
                        {t("header.navbar.logout")}
                    </Nav.Link>
                    <Nav.Link
                        style={{ marginTop: "-40px" }}
                        eventKey="/help"
                        as={Link}
                        to="/help"
                    >
                        {t("header.navbar.help")}
                    </Nav.Link>
                </div>
            </>
        );
    return (
        <>
            <Navbar
                className="mb-12"
                id="nav-border"
                collapseOnSelect
                expand="md"
            >
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse
                    id="basic-navbar-nav"
                    style={{ width: "100%" }}
                >
                    {routeGroup !== "onboarding" && (
                        <>
                            <Nav
                                activeKey={location.pathname.slice(
                                    location.pathname.lastIndexOf("/")
                                )}
                                className="mr-auto"
                                style={{ fontWeight: "bold", fontSize: "120%" }}
                            >
                                {user
                                    ? authenticatedOptions(
                                          location.pathname ==
                                              "/patientControl",
                                          user,
                                          t,
                                          () => setShowTour(true),
                                          isFreeTrial
                                      )
                                    : unauthenticatedOptions(t)}
                                {!isFreeTrial && (
                                    <Nav.Link eventKey="/help" as={Link} to="/help">
                                        {t("header.navbar.help")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav
                                activeKey={location.pathname.slice(
                                    location.pathname.lastIndexOf("/")
                                )}
                                className="ml-auto font-bold text-lg"
                            >
                                {user ? (
                                    <NavDropdown
                                        id="user-selection"
                                        title={`${
                                            user.firstName
                                        } ${user.lastName.slice(0, 1)}.`}
                                    >
                                        {userDropDownItems(user.userType, t, isFreeTrial)}
                                    </NavDropdown>
                                ) : (
                                    ""
                                )}
                            </Nav>
                        </>
                    )}
                </Navbar.Collapse>
            </Navbar>
            <TakeTourModal
                show={showTour}
                onHide={() => setShowTour(false)}
                videoId={language === "es" ? "NkNJzPZTlVA" : "wqtlfTibazA"}
            />
        </>
    );
};
export default Header;